module.exports = __webpack_public_path__ + "img/fylke-10.ad6bf6e3.svg";